/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetUsersAPIKeysIntegratorOptions,
  GetUsersAPIKeysIntegratorResponses,
} from '../types/GetUsersAPIKeysIntegrator'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get user's api keys: admin or integrator only
 * {@link /v1/user/:user_id/apikey}
 */
export function getUsersAPIKeysIntegrator<ThrowOnError extends boolean = true>(
  options: Options<GetUsersAPIKeysIntegratorOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetUsersAPIKeysIntegratorResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/user/{user_id}/apikey',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetUsersAPIKeysIntegratorResponses, ThrowOnError>>,
  )
}
